import { useState, useEffect } from 'react';
import { Vehicle } from 'core/models/vehicle';
import { ChannelLayout } from 'core/models/channel';
import { useChannelResolver } from 'services/useChannelResolver';
import { Project } from 'core/models/project';
import { useVehicle } from 'services/useVehicle';
import { Environment } from 'core/models/environment';

export function useChannelLayout(vehicleId: Vehicle.Id, projectId: Project.Id, environmentId: Environment.Id, subChannels?: number) {
    const [layout, setLayout] = useState<ChannelLayout>();

    const vehicle = useVehicle(vehicleId, projectId, environmentId);

    const channelResolver = useChannelResolver();

    useEffect(() => {
        let available = true;
        (async () => {
            if (!vehicle) return;

            if (!channelResolver) {
                console.error(`cannot obtain channel layout for vehicle ${vehicleId} due to the lack of required dependencies (ChannelResolver)\ncheck out your DI settings.`);
            }

            try {
                const params = { vehicle, projectId, environmentId, subChannels };
                const channelLayout = await channelResolver.resolve(params);
                if (!available) return;

                setLayout(channelLayout);
            } catch (e) {
                console.error(`cannot obtain channel layout for vehicle ${vehicleId} due to: ${JSON.stringify(e)}`);
            }
        })();

        return () => {
            available = false;
        };
    }, [channelResolver, environmentId, projectId, subChannels, vehicle, vehicleId]);

    return layout;
}
